import { forceUpdateService } from './forceUpdateService'

// GNB 항목 이동 시 최신 번들 여부를 확인해, 불일치하면 도착지로 full 네비게이션한다 —
// 강제 업데이트의 유일한 트리거. GNB 목적지는 전부 safe 화면(수업준비·수업·관리·대시보드)이라
// 이 시점의 새로고침은 항상 안전하다. 위험 화면(편집·풀이)은 GNB 목적지가 아니라 트리거되지 않는다.
export const checkOnGnbNavigate = (destinationUrl: string) => {
  void forceUpdateService.checkNow(destinationUrl)
}
